import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate() {
        if (window.location.href.indexOf('/#/fatura') >= 0)
            return false

        //se tiver token e storeId setado, esta liberado todas as paginas das lojas
        if (localStorage.getItem('token') && localStorage.getItem('storeMaskId')) {
            return true
        }
        //se só tiver o token, jogamos pra tela da listagem de lojas pra escolher qual loja acessar
        else if (localStorage.getItem('token')) {
            //return true
            debugger
            if (window.location.href.indexOf('/#/company') >= 0)
                return true
            else {
                //this.router.navigate(['/company/'])
                //window.location.href = "/"
                return true
            }
        }
        //se nao tem nenhum dos dois, jogamos pra fazer o login
        else {
            debugger
            if (window.location.search.length > 0)
                window.location.href = "/#/pages/login" + window.location.search
            else
                this.router.navigate(['/pages/login/' + window.location.search])
        }
    }
}